import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';
import { QuestionIcon } from '@/icons';

export const StyledWrapper = styled.div<{ $isSummaryInfo: boolean }>`
  background: ${({ $isSummaryInfo }) => ($isSummaryInfo ? `${COLORS.YELLOW_PRIMARY}33` : `${COLORS.GRAY}`)};
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  border-radius: 0.375rem;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &&& > div:first-of-type {
    justify-content: flex-end;
  }
`;

export const StyledContentItemsWrapper = styled.div<{ $isRight?: boolean }>`
  display: flex;
  gap: 4rem;
  width: 100%;
  text-align: ${({ $isRight }) => ($isRight ? 'right' : 'left')};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

export const StyledLabelWrapper = styled.div`
  display: flex;
  gap: 0.125rem;
  align-items: center;
  line-height: 1;
`;

export const StyledTooltipIcon = styled(QuestionIcon)`
  cursor: pointer;
`;

export const StyledLabel = styled.div`
  color: ${COLORS.CHARCOAL};
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
`;

export const StyledValue = styled.div`
  color: ${COLORS.BLACK_PRIMARY};
  ${pickThemeFontStyles('26', '26', 'BOLD')};
  white-space: nowrap;
`;

export const StyledProportionsValue = styled.div`
  color: ${COLORS.BLACK_PRIMARY};
  ${pickThemeFontStyles('18', '20', 'BOLD')};
`;

export const StyledTooltipText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${pickThemeFontStyles('14', '14', 'NORMAL')};
  color: ${COLORS.WHITE};
`;
